import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scanner", "tokenInput", "scanResult"]

  toggleScanner() {
    this.scannerTarget.classList.toggle("hidden")
    if (!this.scannerTarget.classList.contains("hidden")) {
      this.tokenInputTarget.focus()
    }
  }

  async scanToken() {
    const token = this.tokenInputTarget.value.trim()
    if (!token) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch("/dashboard/pos/check_ins/scan", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ token })
      })

      const data = await response.json()

      if (data.success) {
        this._showResult("success", `${this._escapeHtml(data.order.order_number)} — ${this._escapeHtml(data.order.customer_name || "Walk-in")} checked in!`)
        this.tokenInputTarget.value = ""
        // Update the row if visible
        const row = document.getElementById(`order-row-${data.order.id}`)
        if (row) {
          setTimeout(() => window.location.reload(), 1000)
        }
      } else {
        this._showResult("error", this._escapeHtml(data.error))
      }
    } catch (err) {
      this._showResult("error", "Network error — please try again")
    }
  }

  _showResult(type, message) {
    const el = this.scanResultTarget
    el.classList.remove("hidden")

    if (type === "success") {
      el.innerHTML = `<p class="text-emerald-400 text-sm font-medium">${message}</p>`
    } else {
      el.innerHTML = `<p class="text-red-400 text-sm font-medium">${message}</p>`
    }

    setTimeout(() => el.classList.add("hidden"), 5000)
  }

  _escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
